var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGuidoSuccess(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 707.37 518.69",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#ec6b7c;}.cls-2{fill:#fff;}.cls-3{fill:#ffef2c;}.cls-4{fill:#ffc7d0;}.cls-5{fill:#ffcd0a;}.cls-6{fill:#ffaa45;}.cls-7{fill:#bcbcbc;}.cls-8{fill:#a5a5a5;}.cls-9{fill:#ad6f31;}.cls-10{fill:#414199;}.cls-11{fill:#2c2a66;}.cls-12{fill:#56bee3;}.cls-13{fill:#61998a;}.cls-14{fill:#5d5dd1;}.cls-15{fill:#78c1b0;}.cls-16{opacity:.65;}.cls-16,.cls-17{fill:#cecece;isolation:isolate;}.cls-17{opacity:.36;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Camada_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "novos_elementos"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M149.78,479.54c9.64,18.07,84,10.44,115.91,21.89,105.92,38.08,301.82,9.76,299.08-51.88-1.48-33.41-101.8-29.71-144.12-42.51-35.74-10.78-128.32,4.2-170.43,8.66-60.04,6.39-117.04,32.69-100.44,63.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M353.05,407.04c-1,4.77-2.49,13.14-4.38,22.61-3.84,19.38-9.48,43.4-17,50.87-11.25,11.12-8-16.65-10.94-16.22s-10.15,21.69-19,18c-4.51-1.9,1.45-14.49-1.69-18.19s-9.46,12.23-16.22,10.91c-10.78-2.12,6.68-18.57,15.19-52.51,1.61-6.38,2.76-12.86,3.45-19.4l33.52-9.94,17.07,13.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M353.05,407.04c-1,4.77-2.49,13.14-4.38,22.61-6.5,1.07-16.78,9.91-30.71,8.48-9-.91-14.81-12-19-15.67,1.61-6.38,2.76-12.86,3.45-19.4l33.52-9.94,17.12,13.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M436.95,248.82s38.23-.85,48.93-37.56,28.46-28.58,27.34-12c-1.12,16.58-12.18,91.64-75.22,107.5l-11.92-10.24,10.87-47.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M446.99,240.18s-9.95,54.12-8,85.3c.31,5.05,.23,44.63,8,51.61-2.1,2.38-4.45,4.53-7,6.41-2.07,1.59-4.22,3.07-6.44,4.43-16.49,10.25-49.6,23.29-107.28,17.87-2.86-.27-6.08-.49-9.52-.78-17.38-1.5-40.3-4.87-50.9-26.09h0c-2.53-5.22-4.22-10.81-5-16.56-2.15-14.57-2.91-31.87-2.84-49.6,.15-44.1,5.37-90.91,7.1-105.15,.14-1.34,.31-2.68,.5-4,0-.23,.05-.35,.05-.35,5.66-37.43,33.48-67.67,70.31-76.41,2.11-.5,4.23-.91,6.39-1.27,.52-2.61,2.6-10,10.09-16.86,9.31-8.58,1.39,14.17,1.39,14.17,0,0,29.58-28.23,33.24-22.65s-11.66,20.06-17.5,24.14c-.31,.21-.66,.44-1,.68h.22c6,.74,11.9,2.08,17.63,4,25.29,8.39,45.75,27.23,56.2,51.74h0c7.95,18.78,9.51,39.65,4.44,59.4l-.08-.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M274.08,302.56l-12.6,10.8c-1.71-.43-3.38-.9-5-1.41-58.44-18.22-71.78-86.22-74.13-108.5-.16-1.43-.26-2.67-.33-3.7-.3-3.27,.28-6.56,1.66-9.53,4.74-9.48,18.31-8.36,27.22,22.24,11.31,38.79,51.71,39.69,51.71,39.69l11.47,50.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M439.95,383.51c-2.12,1.62-4.33,3.14-6.61,4.53-9.57,5.92-24.68,12.75-46.87,16.4-16.14,2.66-36,3.64-60.24,1.37-2.86-.27-6.08-.49-9.52-.78h0c-14.22-11.36-16.6-29.11-16.75-68.14s38.32-55.44,82.08-54.72c43.76,.72,44.37,13.24,45.37,42.06s12.54,59.28,12.54,59.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M352.48,244.23c-11.84,4.15-20.26-4.76-25.94-17.56l-.47-1.06c-1.47-3.49-2.73-7.06-3.78-10.7-.37-1.24-.69-2.48-1-3.69-.09-.36-.17-.7-.24-1.05-3.56-16.52,0-31.06,8.68-33.61,9.51-2.79,21.6,9.85,27,28.24,.33,1.11,.66,2.21,1,3.3,.08,.24,.14,.49,.21,.73s.21,.69,.31,1c.26,.91,.53,1.81,.79,2.7,4.28,14.97,6.47,27.14-6.56,31.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M415.93,200.8c0,.33-.08,.65-.14,1-.11,.9-.26,1.81-.42,2.73-.59,3.28-1.21,6.47-1.91,9.47-.1,.43-.21,.86-.31,1.29-3.22,13.06-8.2,22.24-19,19.65s-12.41-11.9-11.06-24.7v-.33c.07-.79,.17-1.59,.28-2.4l.16-1.21,.12-.8c.3-2.09,.66-4.24,1-6.45,3.26-18.3,12.77-31.93,21.22-30.42,7.98,1.41,12.16,15.41,10.06,32.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M426.42,156.71s-13.12-12.67-24.69-10.78l2.45-14.16s20,4.01,22.24,24.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M358.25,209.86c.26,.91,.53,1.81,.79,2.7-12.27-.76-25.69,3.23-32.5,14.11l-.47-1.06c5.11-9.58,15.64-14.86,26.1-16.3-9.94-4.65-21.56-3.93-30.85,1.91-.09-.36-.17-.7-.24-1.05,10.56-7.78,25.19-8.22,36.65-2.07,.13,.47,.38,1.29,.52,1.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M415.93,200.8c0,.33-.08,.65-.14,1-8.49-3.4-18.54-2.91-25.87,3,8.81-1.37,18.17,2,23.54,9.17-.1,.43-.21,.86-.31,1.29-7.58-9.06-20-9.33-30.06-5,0-.12,.32-2.51,.34-2.7h0l.16-1.21h0c7-9.31,22.23-11.04,32.34-5.55Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "413.06 225.2 409.89 221.63 405.06 223.63 399.9 237 415.51 230.65 413.06 225.2"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-3",
    cx: 348.05,
    cy: 243.16,
    rx: 23.57,
    ry: 10.53,
    transform: "translate(-30.62 51.13) rotate(-8.05)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "402.44 231.42 409.76 232.34 420.82 227.42 412.82 226.5 402.44 231.42"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-7",
    points: "404.86 230.31 404.43 226.5 408.19 224.39"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "413.65 221.29 405.91 225.68 403.27 231.07 412.82 226.5 413.65 221.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M409.41,223.69c-.12,.67-.05,1.36,.2,2,1,1.52,3.07,.89,3.07,.89l6.47,1.59-12,5.55-2.3-3.4,1.44-4.86,3.12-1.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M416.12,228.93l9.82,.28c5-4.54,.46-8.06,.46-8.06l-10.05-.83,.12,4.31-.35,4.3Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "422.11 222.25 425.02 222.38 425.37 223.03 422.37 222.91 422.11 222.25"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M415.51,230.65c-2.37,2.35-4.64,4.79-6.78,7.27-8.22,9.67-15.38,20.18-21.38,31.36,0,0-14.71,4.51-23.14-4.91s-3.13-25.33-3.13-25.33c15.45-16.53,48.81-17.42,48.81-17.42-3.72,2-4,8.2-4,8.2,2.85,2.37,9.62,.83,9.62,.83Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-13",
    cx: 416.35,
    cy: 224.63,
    r: 4.31
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M386.35,129.04c-15-2.54-25,2.48-25.45,2.73l7.82-6.69c5.99,.73,11.9,2.05,17.63,3.96Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M265.81,378.91c-2.53-5.22-4.22-10.81-5-16.56-2.15-14.57-2.91-31.87-2.84-49.6,3.52,1.3,7.6,2.65,9.26,2.65,0,0-7.05,38.5-1.42,63.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M335.94,126.83c-3.43,10.19-10.79,18.59-20.44,23.34-10.42,5.16-24.08,2.33-24.55,2.15,12.27-12.6,27.88-21.44,44.99-25.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M335.94,126.83c-10.22,13.76-22,20.11-30.93,23h0c-4.53,1.57-9.28,2.41-14.07,2.47l-8.13-41.26v-.21l-4.84-24.51-3.85-19.53,12.72,12.35,49.1,47.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M304.72,178.64s6.91-19.72,19.72-23.79l-9.86-13.21s-18.4,14.4-9.86,37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M408.73,237.92c-8.22,9.67-15.38,20.18-21.38,31.36,0,0-14.71,4.51-23.14-4.91,6.53,4.91,18.64,2.61,22.14-3,5.74-9.3,13.36-17.28,22.38-23.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M365.37,238.97c1.41-1.07,13.67-10.08,26.7-12,.28-.09,.57,.06,.66,.34,.09,.28-.06,.57-.34,.66-6.29,3.42-23.15,13-27.52,20.13-.11,.27-.41,.39-.68,.28-.21-.08-.34-.29-.32-.51-.1-2.93,.34-5.86,1.31-8.63,.03-.11,.1-.2,.19-.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M286.8,79.15l-6.09-1.05-1,6.9s-.56,1.33-1.73,1.33l-3.85-19.53,12.67,12.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M289.18,70.33l-7.05-.12,3.62,6c.26,.42,.13,.98-.29,1.24-.29,.18-.66,.18-.95,0l-6-3.63,.12,7c.01,.5-.38,.91-.88,.92-.34,0-.65-.17-.81-.47l-3.41-6.15-3.43,6.16c-.24,.44-.78,.6-1.22,.36-.3-.16-.48-.48-.47-.82l.12-7-6,3.63c-.42,.26-.98,.13-1.24-.29-.18-.29-.18-.66,0-.95l1.46-2.45,2.16-3.59-7,.12c-.5,0-.91-.41-.91-.91,0-.33,.18-.63,.46-.79l2.26-1.25,3.89-2.17-6.16-3.42c-.44-.24-.6-.78-.36-1.22,.16-.3,.48-.48,.82-.47l7,.11-3.62-6c-.26-.42-.13-.98,.29-1.24,.29-.18,.66-.18,.95,0l6,3.61-.12-7c-.01-.5,.38-.91,.88-.92,.34,0,.65,.17,.81,.47l3.43,6.16,3.41-6.15c.24-.44,.78-.6,1.22-.36,.3,.16,.48,.47,.47,.81l-.12,7,6.05-3.61c.43-.25,.98-.11,1.23,.31,.17,.29,.17,.64,0,.93l-3.62,6,7.05-.11c.5-.01,.91,.38,.92,.88,0,.34-.17,.65-.47,.81l-6.16,3.42,6.17,3.42c.46,.21,.66,.75,.45,1.21-.17,.37-.55,.58-.95,.52Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M264.82,70.21l-7,.12c-.5,0-.91-.41-.91-.91,0-.33,.18-.63,.46-.79l2.26-1.25-.9,1.47,6.09,1.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M289.18,70.33l-7.05-.12,3.62,6c.26,.42,.13,.98-.29,1.24-.29,.18-.66,.18-.95,0l-6-3.63,.12,7c.01,.5-.38,.91-.88,.92-.34,0-.65-.17-.81-.47l-3.41-6.15-3.43,6.16c-.24,.44-.78,.6-1.22,.36-.3-.16-.48-.48-.47-.82l.12-7-6,3.63c-.42,.26-.98,.13-1.24-.29-.18-.29-.18-.66,0-.95l1.46-2.45,.16,1.39,6.2-3,1,3.65,2-3.58,3.75,3.21,1.61-2.94,4.54,2.07-1.83-5.02,5.3-1-2-3.3,6.17,3.42c.42,.28,.54,.84,.26,1.26-.16,.25-.43,.4-.73,.41Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M305.44,129.04c3.37,7.63,15.51-3.45,14.63-6.82-.76-2.88-24.54-28.73-31.58-35.69-.83-.82-2.9-.45-2.11,1.53,4.19,10.45,15.94,33.87,19.06,40.98Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M305.01,149.84h0c-4.53,1.57-9.28,2.41-14.07,2.47l-8.13-41.27c.62,2.78,7.38,32.5,11.49,36.39,4.31,4.09,10.71,2.41,10.71,2.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M284.1,62.04l-2.14,1.15c-5.68-.93-11.46-.93-17.14,0l-2.14-1.15c-.26-.14-.36-.46-.23-.71,.09-.18,.28-.29,.48-.29h3.77l-2.46-5c-.13-.26-.02-.57,.24-.7,.15-.07,.33-.07,.47,0l4.92,2.56-.28-4.73c-.05-.29,.14-.56,.43-.61,.23-.04,.47,.08,.57,.29l2.84,4.14,2.85-4.14c.16-.24,.48-.3,.72-.14,.15,.1,.24,.28,.23,.46l-.28,4.73,4.92-2.56c.26-.13,.58-.02,.71,.24,.07,.14,.07,.31,0,.45l-2.47,5h3.77c.29,.02,.51,.27,.5,.56-.01,.19-.12,.35-.29,.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M262.59,252.15c-16.05,4.35-34.9,5.72-51.77-18.44-7.17-10.26-10.92-34-17-40.2-3.35-3.39-6.59-4.31-10.14-3.29,4.74-9.48,18.31-8.36,27.22,22.24,11.28,38.79,51.69,39.69,51.69,39.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M256.46,311.95c-58.44-18.22-71.78-86.22-74.13-108.5,1.21,5.5,13.44,75.98,74.13,108.5Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "182.73 112.7 167.83 128.11 167.83 137.44 180.13 125.07 182.73 112.7"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "67.63 48.58 61.84 37.32 57.09 36.31 61.69 45.57 67.63 48.58"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M237.77,22.04s-1.79,7.92,1.84,9.28,2,8.9-1.11,12.39l-2.6-2.85s4-7.44,5.16-10.58-1.52-4.06,.11-8.2l-3.4-.04Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "250.22 71.89 245.46 76.51 243.64 85.62 248.13 82.92 250.22 71.89"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M70.99,144.16c-3.74,5.44-5.05,8.51,0,8.24s2.93-12.49,0-8.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M155.68,64.58c.48-6.59,.06-9.9-4.16-7.12s3.78,12.26,4.16,7.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M51.58,86.19c-1.21,5.42,1.33,9,3.72,7.45s-3.39-8.94-3.72-7.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M689.54,132.04s4.42,7.81,10.45,6.38,7.38-11.68,7.38-11.68l-5.16,.23s2.2,14.09-5.23,15.6-11.07-8.34-11.07-8.34l3.63-2.19Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "122.88 122.62 111.42 131.92 113.29 133.79 122.88 122.62"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "81.9 114.11 82.96 122.62 89.08 117.83 84.56 112.71 81.9 114.11"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "235.69 131.55 229.86 125.26 227.69 132.71 234.34 134.24 235.69 131.55"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "189.85 165.42 200.29 158.61 205.71 168.18 200.05 164.47 190.77 166.37 189.85 165.42"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M131.28,20.14c-3.19,4.62-4.44,2.75-2.84,12.05s-9.85,9.84-9.71,15.7c.08,3.08,9.84,13.85,5,19.16s-8.31,4.75-8.31,4.75l-1.86-2.57s12.49-6.19,10.62-13.63-4.52-8.22-3.05-13.16,8.9-8.92,9.17-13.44,2.65-6.59,2.65-6.59l-1.67-2.27Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "640.52 345.09 626.9 333.95 618.14 336.39 629.06 345.67 640.52 345.09"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "149.78 377.86 160.68 369.02 161.9 363.93 152.95 371.03 149.78 377.86"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M151.85,234.18s-6.64,6.29-5.28,9.43-4.91,9.16-9.31,10.72l.33-4s7.69-4.7,10.62-7,1.86-4.49,5.76-7.42l-2.12-1.73Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "90.36 193.13 84.14 194.86 76.66 202.22 81.38 202.1 90.36 193.13"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M210.05,382.33c-4.9-2.39-7.7-2.92-7.74,2.15s11.56-.29,7.74-2.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M2.18,234.17c4.89-5.75,6.92-9,2.31-8.66s-6.17,13.16-2.31,8.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M291.75,203.44c-5,.19-8.56,3.72-7.2,5.74s8.57-5.79,7.2-5.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M219.49,272.59c-5.49,1.53-8.4,6.6-19.42,11.8s-13.88-1.47-17-1.66-8.67,6-17.15,8.16l-5.68,5s13.05-4.86,19.92-9,5,7.08,18.1,1.41,18.16-12.67,21.09-12.42l.14-3.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M656.45,167.04s-2.61,9.42,2.2,11.26,12.79-6.79,12.79-6.79l-3.42-2.47s-8.4,14-14.16,11.5-1.22-13.38-1.22-13.38l3.81-.12Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "667.17 86.7 643.04 78.76 637.91 82.58 667.17 86.7"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "527.64 350.84 519.59 354.14 523.73 359.12 528.79 353.18 527.64 350.84"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "88.09 249.51 88.77 240.73 82.21 246.4 85.37 251.26 88.09 249.51"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "44.53 305.07 55.88 304.31 52.66 315.86 51.65 309.53 44.45 306.42 44.53 305.07"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M621.23,274.71c-4.16-2-2.33-3.8-11.15,.26s-8.68-7.46-14.18-5.78c-2.9,.88-13.57,13.63-18.27,10.07s-4-7.21-4-7.21l2.51-2.57s5.1,11.11,12.19,7.27,8-6.75,12.52-6.55,7.87,6.74,12.1,5.83,6,1,6,1l2.28-2.32Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "426.98 193.51 441.23 177.49 440.84 168.17 429.06 181.04 426.98 193.51"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "432.99 326.22 439.24 337.23 444.03 338.04 439.05 328.99 432.99 326.22"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M599.11,75.15s1.46-8-2.23-9.21-2.37-8.8,.6-12.42l2.72,2.74s-3.67,7.6-4.72,10.79c-1.05,3.19,1.68,4,.23,8.19l3.4-.09Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "605.94 239.34 610.5 234.53 611.94 225.35 607.57 228.23 605.94 239.34"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M479.18,39.94c3.52-5.6,4.7-8.72-.34-8.24s-2.44,12.6,.34,8.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M515.82,170.71c-.21,6.6,.35,9.89,4.46,6.94s-4.29-12.1-4.46-6.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M447.46,287.98c1-5.47-1.7-9-4-7.29s3.72,8.78,4,7.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M526.51,274.45c4-4.24,2.89-9.23,9.33-19.12s14.26-7.31,17.39-9.07,3.62-9,10-15.44l1.57-6.57s-8.62,10.88-11.94,17.63-10.16-1.57-18.2,9.86-7.48,18.93-10.48,20.52l2.33,2.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M551.52,92.14s-4.75-7.62-10.71-5.94-6.89,12-6.89,12l5.14-.43s-2.77-14,4.59-15.81,11.4,7.87,11.4,7.87l-3.53,2.31Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "614.44 158.2 625.51 148.42 623.56 146.64 614.44 158.2"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "416.01 261.34 414.59 252.89 408.68 257.92 413.41 262.85 416.01 261.34"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "261.62 292.93 267.71 298.97 269.57 291.43 262.86 290.19 261.62 292.93"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "587.34 157.57 577.19 164.81 571.38 155.47 577.19 158.95 586.38 156.66 587.34 157.57"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M222.39,238.8c3-4.75,4.32-2.93,2.34-12.16s9.43-10.24,9-16.08c-.2-3.08-10.4-13.44-5.78-18.94s8.11-5.09,8.11-5.09l2,2.49s-12.23,6.7-10.06,14.06,4.85,8,3.6,13-8.53,9.29-8.61,13.81-2.37,6.7-2.37,6.7l1.77,2.21Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "330.89 30.27 344.96 40.82 353.6 38.03 342.31 29.2 330.89 30.27"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "313.21 75.51 302.69 84.79 301.68 89.94 310.32 82.47 313.21 75.51"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M497.18,68.39s3.83-4.1,2-6.89,1.8-6.73,4.93-7.31l.63,3.2c-2.34,1.21-4.62,2.54-6.82,4-1.8,1.38-.45,3.39-2.87,5.17l2.13,1.83Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "358.29 139.57 364.44 137.59 371.61 129.92 366.9 130.23 358.29 139.57"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M401.85,43.43c5,2.18,7.81,2.59,7.64-2.48s-11.54,.77-7.64,2.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M486.92,159.5c-4.63,5.95-6.53,9.27-1.94,8.75s5.57-13.4,1.94-8.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M347.83,80.59c5-.39,8.4-4.06,7-6s-8.37,6.11-7,6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M453.34,202.04c3,2.81,10.65,3.55,19.67,8.81s-.14,8,0,9.83,9.82,3.81,14.13,8.18l7.93,2.32s-8.82-6.46-15.74-9.58,9.43-4-.56-10.38-20.74-8-20.8-9.65l-4.63,.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M479.18,122.26s2.22-9.53-2.66-11.16-12.5,7.32-12.5,7.32l3.53,2.34s7.81-14.34,13.66-12.08,1.81,13.36,1.81,13.36l-3.84,.22Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "363.44 0 387.89 6.93 392.85 2.9 363.44 0"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "374.15 41.32 382.05 37.69 377.7 32.89 372.89 39.03 374.15 41.32"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "422.6 94.7 422.29 103.5 428.61 97.57 425.25 92.84 422.6 94.7"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "445.41 68.99 434.1 70.22 436.83 58.55 438.11 64.84 445.43 67.64 445.41 68.99"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M287.76,19.17c4.24,1.87,2.48,3.71,11.13-.71s9,7.09,14.41,5.19c2.85-1,13-14.19,17.83-10.83s4.28,7,4.28,7l-2.4,2.67s-5.56-10.88-12.49-6.75-7.68,7.07-12.23,7.06-8.14-6.41-12.33-5.32-6.07-.72-6.07-.72l-2.13,2.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M414.06,223.14c1.41-.22,2.84-.3,4.26-.23,.2,0,.37-.16,.37-.37,0-.12-.06-.23-.15-.3-.79-.71-1.84-1.04-2.89-.9-.83,.14-1.58,.58-2.1,1.25-.26,.34-.18,.65,.51,.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M426.36,222.24c-1.11,0-4.41-.22-4.41-.22-.5,0-.98-.21-1.3-.6-.06-.09-.25-.36,.28-.31l4.33,.3c.4,.02,.78,.16,1.08,.42l.17,.16c.11,.1,.08,.26-.15,.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M433.34,388.04c-9.57,5.92-24.68,12.75-46.87,16.4,7.6-4.93,13-33.54,13-33.54,0,0,25.65,7.06,27.47,4.86l6.4,12.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M394.78,403.09c5.67-9.82,1.19-28.94,5.87-37.17s12.75-6,19.16-2.39c10.37,5.85,7.14-2.26,12.75-14,4.93-10.32,15.13,3.38,19.52,4.53s10.22-19.68,16.12-10.88-7.3,38.1-15.95,45.55-57.47,14.36-57.47,14.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M414.04,366.72c.38-.1,.61-.5,.51-.88-.07-.28-.31-.49-.6-.53-4.74-.74-9.18-.86-10.25,2.78-.64,2.67-.77,5.44-.4,8.16,.04,.4,.4,.68,.79,.64,.26-.03,.49-.2,.59-.44,1-2.49,2.68-6.15,3.79-7.28s3.48-1.87,5.57-2.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M438.41,349.23c-.1-.02-.21-.02-.31,0-.71,.16-3.51,1.23-5.87,8.17l-.81,2.38c-.12,.38,.08,.78,.46,.91,.29,.09,.6,0,.79-.24,1.93-2.48,4.55-4.94,7.28-4.86,2.13,.14,4.24,.51,6.29,1.11,.38,.11,.78-.12,.89-.5,.06-.23,0-.48-.15-.66-1.8-2.18-5.2-5.64-8.57-6.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M465.4,345.83c-.89-1.11-2.71,.55-4.28,2.82-.19,.36-.04,.8,.31,.98,.2,.1,.43,.11,.64,.02,1-.5,2-.66,2.69,.24,.27,.3,.73,.33,1.03,.06,.13-.12,.22-.28,.24-.45,.22-1.26,0-2.56-.63-3.67Z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGuidoSuccess);
export default __webpack_public_path__ + "static/media/guido_success.ac460ae4020d7f7b6abe540666748e96.svg";
export { ForwardRef as ReactComponent };